import { render, staticRenderFns } from "./instagram-ads-vs-facebook-ads-quelles-differences-et-quel-choix-pour-votre-marque.vue?vue&type=template&id=1c8a4e77&"
import script from "./instagram-ads-vs-facebook-ads-quelles-differences-et-quel-choix-pour-votre-marque.vue?vue&type=script&lang=js&"
export * from "./instagram-ads-vs-facebook-ads-quelles-differences-et-quel-choix-pour-votre-marque.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports